import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../DatePickerTheme.css';

const SelectByDateRange = ({ fetchReports, title, theme }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState('');
    const containerRef = React.useRef(null);

    // No longer needed with react-datepicker

    const handleSubmit = () => {
        if (!startDate || !endDate) {
            setError('Please select both start and end dates.');
            return;
        }
        if (startDate > endDate) {
            setError('Start date cannot be after end date.');
            return;
        }
        setError('');
        
        const weekData = {
            startDate: startDate.toISOString().split('T')[0],
            endDate: endDate.toISOString().split('T')[0]
        };
        
        fetchReports(weekData);
    };

    // Theme-based styling
    const isLightTheme = theme === 'light';
    const inputStyle = {
        padding: '5px',
        textAlign: 'center',
        backgroundColor: isLightTheme ? '#fff' : '#333',
        color: isLightTheme ? '#333' : '#fff',
        border: isLightTheme ? '1px solid #ccc' : '1px solid #555',
    };

    const dateInputStyle = {
        ...inputStyle,
        width: '100%',
        borderRadius: '3px',
        padding: '8px',
        position: 'relative',
        zIndex: 1000,
    };

    const datePickerContainerStyle = {
        flex: 1,
        position: 'relative',
        zIndex: 'auto',
    };

    return (
        <div ref={containerRef} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px',
            position: 'relative',
        }}>

            <h2>{title}</h2>

            {/* Date Range Selection */}
            <div style={{ width: '100%', display: 'flex', gap: '10px', alignItems: 'end' }}>
                <div style={datePickerContainerStyle}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                        From:
                    </label>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date()}
                        placeholderText="Start Date"
                        dateFormat="dd/MM/yyyy"
                        customInput={<input style={dateInputStyle} />}
                        popperPlacement="auto"
                        showPopperArrow={false}
                        calendarClassName={isLightTheme ? 'light-theme' : 'dark-theme'}
                        popperContainer={({ children }) => containerRef.current ? 
                            ReactDOM.createPortal(children, containerRef.current) : children
                        }
                    />
                </div>
                <div style={datePickerContainerStyle}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                        To:
                    </label>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={new Date()}
                        placeholderText="End Date"
                        dateFormat="dd/MM/yyyy"
                        customInput={<input style={dateInputStyle} />}
                        popperPlacement="auto"
                        showPopperArrow={false}
                        calendarClassName={isLightTheme ? 'light-theme' : 'dark-theme'}
                        popperContainer={({ children }) => containerRef.current ? 
                            ReactDOM.createPortal(children, containerRef.current) : children
                        }
                    />
                </div>
            </div>

            {/* Submit button */}
            <button
                className="hoverable"
                onClick={handleSubmit}
                style={{
                    padding: '5px 10px',
                    width: '100%',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                Submit
            </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default SelectByDateRange;
